// removed by extract-text-webpack-plugin
module.exports = {"previewTitle":"src-components----article-preview-module---previewTitle---16pYm","preview":"src-components----article-preview-module---preview---F8ZWM","previewBody":"src-components----article-preview-module---previewBody---cWoy-","tag":"src-components----article-preview-module---tag---27JAs","meta":"src-components----article-preview-module---meta---1o0hi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/article-preview.module.css
// module id = 53
// module chunks = 35783957827783 80228475665765 212839066777427